import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { formattedStat } from 'shared/src/utils/formatting'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { sansSerifFontFamily } from 'utils/styles'
import viewsIcon from '../../../assets/views-icon.svg'

const useStyles = createUseStyles({
  container: {
    paddingTop: 7,
    paddingBottom: 7,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    fontFamily: sansSerifFontFamily,
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '160%',
    letterSpacing: '0.2px',
    color: 'white',
  },
})

interface Props {
  views: number
  className?: string
}

export const Views: FC<Props> = flowMax(
  addDisplayName('Views'),
  addProps(({ views }) => ({
    views: formattedStat(views),
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ views, classes, className, t }) => (
    <div className={cx(classes.container, className)}>
      <img src={viewsIcon} alt={t('media.viewsAlt')} />
      <div>{views}</div>
    </div>
  )
)
